export const messages = {
    'ru' : {
        'add_new_block' : 'Добавить новый блок',
        'cancel' : 'Отменить',
        'confirm_delete_block' : 'Вы уверены, что хотите удалить этот блок? Все элементы внутри будут удалены!',
        'confirm_delete_element' : 'Вы уверены, что хотите удалить этот элемент?',
        'confirm_delete_module' : 'Вы уверены, что хотите удалить мероприятия?',
        'content_placeholder' : 'Введите содержание здесь',
        'copy' : 'Скопировать',
        'copy_success' : 'Блок был успешно скопирован!',
        'copy_to_ru' : 'Скопировать блок в русскую версию',
        'copy_to_kg' : 'Скопировать блок в кыргызскую версию',
        'copy_to_tm' : 'Скопировать блок в туркменскую версию',
        'copy_to_tj' : 'Скопировать блок в таджикскую версию',
        'delete' : 'Удалить',
        'drag_files_here' : 'Перетащите ваши файл(ы) сюда или нажмите, чтобы загрузить.',
        'file' : 'Файл',
        'from_until' : 'Даты',
        'full_width' : 'Полная',
        'half_width' : 'Половина',
        'header' : 'Заголовок',
        'html' : 'Код',
        'image' : 'Изображение',
        'image_not_found' : 'Изображение не найдено',
        'location' : 'Место',
        'module_name' : 'Описание мероприятия',
        'move' : 'Передвинуть',
        'new_element' : 'Добавить',
        'new_event' : 'Новое мероприятия',
        'not_assigned' : '-',
        'one_third' : 'Одна третья',
        'options' : 'Настройки',
        'paragraph' : 'Параграф',
        'quarter_width' : 'Четвертая',
        'save' : 'Сохранить',
        'separator' : 'Разделитель',
        'trainer' : 'Тренер',
        'two_thirds' : 'Две третьих',
        'upload_file' : 'Загрузить файл',
        'upload_image' : 'Загрузить изображение',
        'uploading' : 'Загрузка...',
    },
    'kg' : {

    },
};


// WEBPACK FOOTER //
// ./resources/js/lang/Messages.js